import { ComponentProps, FC, PropsWithChildren } from "react";
import classes from './myButton.module.scss'

export const MyButtonSecondary: FC<PropsWithChildren<ComponentProps<'button'>>> = ({
    children,
    className = '',
    type = 'button',
    ...props
}) => {

    return (
        <button
            {...props}
            type={type}
            className={`${classes.secondaryButton} ${className}`.trim()}
        >
            {children}
        </button>
    )
}
